<app-side-menu>
  
  <div class="groups-table">
    <app-table
      [title]="'Grupos'"
      [data]="groups"
      [columns]="columns"
      [loading]="loading"
      [showSearch]="true"
      [searchPlaceholder]="'Pesquisar grupos...'"
      [clickable]="false"
      [disablePagination]="false"
      [totalItemsFromBackend]="totalItems"
      [currentPageFromBackend]="currentPage"
      [actions]="actions"
      (searchChange)="onSearch($event)"
      (pageChange)="onPageChange($event)"
      (actionClick)="handleAction($event)">
      <button
        *appHasPermission="'Groups.Manage'"
        table-header-action
        class="btn btn-primary new-group-btn"
        (click)="createGroup()">
        <i class="fas fa-plus me-2"></i>
        Novo Grupo
      </button>
    </app-table>
  </div>

</app-side-menu>
